{
    "common": {
        "action": "Action",
        "back": "Return",
        "clockOut": "End shift",
        "from": "from",
        "logout": "Log out",
        "next": "Next",
        "skip": "Skip",
        "submit": "Submit",
        "until": "until",
        "wholeDay": "Whole day"
    },
    "containers": {
        "cacheBuster": {
            "updateAvailable": "An update is available!",
            "reload": "Reload"
        },
        "clockOutScreen": {
            "title": "Are you ready to finish your shift, :firstName:?",
            "titleNoName": "Ready to finish your shift?"
        },
        "commentScreen": {
            "startedWithoutShiftTitle": "Tell us why you started an unplanned shift.",
            "trackDivergenceTitle": "It seems your working hours differ from the schedule, what is your reason? "
        },
        "happinessScreen": {
            "title": "How did you like your shift?"
        },
        "inactiveScreen": {
            "title": "Sorry, you don't have access to ValkTimer",
            "intro": "Your account has been deactivated, this is why you don't have access to ValkTimer.",
            "contact": "Is this not correct or do you have any questions? Don't hestitate to contact your manager or HR. "
        },
        "goodbyeScreen": {
            "title": "Have a nice day and see you soon!"
        },
        "loginScreen": {
            "enterPincode": "Please enter your pin number",
            "userNotFound": "Sorry, this combination is not correct. Fill in your employee number. ",
            "title": "Welcome, please fill in your employee number."
        },
        "masterLoginScreen": {
            "title": "Welcome, enter the master code to access the ValkTimer",
            "wrongMasterCode": "Unfortunately, this combination is incorrect. "
        },
        "mealScreen": {
            "title": "Please pick the meal you had"
        },
        "pauseScreen": {
            "title": "How long was your break?"
        },
        "selectShiftScreen": {
            "pleasantWorkDay": "Have a nice shift, :firstName:!",
            "unplannedShift": "Unscheduled shift",
            "whichShiftDoYouWantToStart": "Which shift would you like to start, :firstName:?"
        }
    },
    "errors": {
        "unknownError": "An unknown error has occurred, please try again later"
    },
    "types": {
        "mealType": {
            "hot": "Hot",
            "bread": "Bread",
            "none": "None"
        }
    }
}
